export type Platform = {
  id: number,
  name: string,
  stream_url: string,
  getclip_api_url: string,
  html_short_description: string,
  current_item_name: string | null,
};

let fetchPlatformsPromise: Promise<Platform[]> | null = null;

async function doFetchPlatforms(): Promise<Platform[]> {
  const response = await fetch("/platforms.json", {
    method: "GET",
    credentials: "same-origin",
    headers: {
      accept: "application/json"
    }
  });

  if (!response.ok) {
    console.error("Failed to load platforms", response);
    return [];
  }

  return await response.json();
}

/**
 * Fetch platforms
 *
 * Restricts to a single call per page load, will resolve with the platforms
 * whenever it’s returned
 *
 * @return {Promise}
 */
export default function fetchPlatforms(): Promise<Platform[]> {
  return fetchPlatformsPromise ||= doFetchPlatforms();
}
